module.exports = __webpack_public_path__ + "static/header-contact-41509f20f3d63e4987fa07eec74b4523.jpg";